var UIDropdown = (function ($) {

    UIDropdown = function () {
        var that = this;

        // DOM

        // CONST

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UIDropdown.prototype.event_names = {
        open: 'dropdown-open',
        close: 'dropdown-close',
        close_dd: 'dd_close'
    };

    UIDropdown.prototype.class = {
        is_active: 'is-active',
        desktop: 'js-dd-desktop',
        tablet: 'js-dd-tablet',
        mobile: 'js-dd-mobile'
    };

    UIDropdown.prototype.selectors = {
        dd_wrapper: '.dd-wrapper',
        dd_button: '.js-dd-button',
        dd: '.dd'
    }

    UIDropdown.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UIDropdown.prototype.initEventHandlers = function () {
        const that = this;

        $.sa.$document.on('click', '.js-dd-button', function (e) {
            var button = this;
            
            that.dropDownShow(button, e);
        });
        
        $.sa.$document.on('click', '.js-dd-close', function () {
            that.hideAll();
        });
        
        $.sa.$document.on('click', function (e) {
            if (!$(e.target).parents(that.selectors.dd_wrapper).length) {
                that.hideAll();
            } else {
                that.hideNested();
            }
        });
        
        $.sa.$document.on('touchstart', function (e) {
            if (!$(e.target).parents(that.selectors.dd_wrapper).length) {
                that.hideAll();
            } else {
                that.hideNested();
            }
        });

        $.sa.$document.keyup(function(e){
            if (e.key === 'Escape') {
                that.hideAll();
            }
        });
        
        $.sa.$document.on('click', 'a', function () {
            var $link = $(this),
                $dd_wrapper = $link.parents(that.selectors.dd_wrapper);
            
            if ($dd_wrapper.length) {
                that.hideCurrent($dd_wrapper);
            }
        });
    };

    UIDropdown.prototype.dropDownShow = function (button, event = null) {
        var that = this,
            $button = $(button),
            $wrapper = $button.parents(that.selectors.dd_wrapper),
            wrapper_desktop = $wrapper.hasClass(that.class.desktop),
            wrapper_tablet = $wrapper.hasClass(that.class.tablet),
            wrapper_mobile = $wrapper.hasClass(that.class.mobile);

        if (
            (wrapper_desktop && !$.sa.is_desktop()) ||
            (wrapper_tablet && !$.sa.is_tablet()) ||
            (wrapper_mobile && !$.sa.is_mobile())
        ) {
            if (!!event) {
                event.preventDefault();
            }
            return false;
        }

        // second click to button close dropdown
        if (!$button.hasClass(that.class.is_active)) {
            that.show($wrapper);
        } else {
            that.hideCurrent($wrapper);
        }
    };
    
    UIDropdown.prototype.show = function ($wrapper) {
        const that = this;
        
        // Prevent blinking dropdown if try to open nested dropdown second and more times
        if (!$wrapper.parents(that.selectors.dd_wrapper).length) {
            that.hideAll();
        }
        
        setTimeout(function () {
            $wrapper.children('.dd').addClass(that.class.is_active);
            $wrapper.children('.js-dd-button').addClass(that.class.is_active);
            that.__initContentScrollbar($wrapper);
            $wrapper.trigger(that.event_names.open);
        }, 0);
    };

    UIDropdown.prototype.__initContentScrollbar = function ($wrapper) {
        var $dd = $wrapper.find('.dd'),
            $content = $dd.find('.content');
        
        if (!$content.length) {
            return false;
        }
        
        var $content_scroll_wrapper = $content.parent('.scroll-wrapper');
        
        if (!$content_scroll_wrapper.length) {
            return false;
        }
        
        var dd_height = $dd.height() || 0,
            content_real_height = $content.height() || 0;
       
        if (!content_real_height) {
            return false;
        }
        
        if (content_real_height > dd_height) {
            $.uiScrollbar($content);
            $content.closest('.scroll-wrapper').css({'max-height': dd_height});
        }
    };

    UIDropdown.prototype.hideCurrent = function ($wrapper) {
        var that = this,
            $dd = $wrapper.children('.dd'),
            $dd_button = $wrapper.children('.js-dd-button'); 

        if ($dd.hasClass(that.class.is_active)) {
            $dd.removeClass(that.class.is_active);
            $dd_button.removeClass(that.class.is_active);
            $dd.trigger(that.event_names.close)
               .trigger(that.event_names.close_dd);
        }
    };

    UIDropdown.prototype.hideNested = function () {
        var that = this,
            $dd = $.sa.$document.find('.dd .dd'),
            $dd_button = $.sa.$document.find('.dd .js-dd-button');

        if ($dd.hasClass(that.class.is_active)) {
            $dd.removeClass(that.class.is_active);
            $dd_button.removeClass(that.class.is_active);
            $dd.trigger(that.event_names.close)
               .trigger(that.event_names.close_dd);
        }
    };
    
    UIDropdown.prototype.hideAll = function () {
        var that = this;

        $.sa.$document.find(that.selectors.dd_wrapper).each(function () {
            var $wrapper = $(this),
                $dd = $wrapper.find('.dd'),
                $dd_button = $wrapper.find('.js-dd-button');

            if ($dd.hasClass(that.class.is_active)) {
                $dd.removeClass(that.class.is_active);
                $dd_button.removeClass(that.class.is_active);
                $dd.trigger(that.event_names.close)
                   .trigger(that.event_names.close_dd);
            }
        });
    };

    UIDropdown.prototype.isActive = function ($dd) {
        const that = this;
        return $dd.hasClass(that.class.is_active);
    }

    return UIDropdown;
})($);
